import { ContactRound } from "lucide-react"

import { lazyPage } from "../lazy-page"
import { defineDashboardModule } from "../types"

export const contact = defineDashboardModule({
  id: "contact",
  nav: [
    {
      group: "Publishing",
      title: "Contact card",
      to: "/contact-card",
      icon: ContactRound,
    },
  ],
  routes: [
    {
      path: "/contact-card",
      component: lazyPage(
        () => import("./routes/contact-card"),
        "ContactCardPage"
      ),
    },
  ],
})
